import React, { useState, useEffect, forwardRef, ReactElement } from 'react';
import api from "../components/api";
import TextInput from '../components/TextInput'
import toast from 'react-hot-toast';

import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import Slide from "@mui/material/Slide";
import { TransitionProps } from "@mui/material/transitions";


const Transition = forwardRef(function Transition(
    props: TransitionProps & { children: ReactElement<any, any> },
    ref
) {
    return <Slide direction="up" ref={ref} {...props} />;
});


interface iClienteWhatsapp {
    
    clienteWhatsapp_id: number,
    nome: string,
    telefone: string,

}


const ClienteWhatsapp = (props: any) => {

    const [resultado, setResultado] = useState<React.ReactNode>()

    const [nome, setNome] = useState<string>('')
    const [telefone, setTelefone] = useState<string>('')
    const [clienteWhatsapp_id, setClienteWhatsapp_id] = useState<number | undefined>()
    
    const [open, setOpen] = useState(false)
    const [titulo, setTitulo] = useState('')
    const [frase, setFrase] = useState('')
    const [acao, setAcao] = useState('')


    const dadosUsuarios = sessionStorage.getItem('dadosUsuarios')
    const [usuario_id_session, setUsuario_id_session] = useState<number | undefined>()

    useEffect(() => {

        if (dadosUsuarios) {

            var dados = JSON.parse(dadosUsuarios)

            setUsuario_id_session(dados.usuario_id)

            //setCliente_id(dados.cliente_id ? Number(dados.cliente_id) : undefined)


        }

    }, [dadosUsuarios])

    const validaSalvar = () => {

        if (telefone == '') {

            toast.error('Preencha o número de Whatsapp')
            return false
            
        }

        if (nome == '') {
            toast.error('Preencha o nome!')
            return false

        }

        setOpen(true)
        setTitulo('Confirmação')
        setFrase('Deseja salvar o contato?')
        setAcao('salvar')
        
    }

    const validaApagar = () => {

        setOpen(true)
        setTitulo('Confirmação')
        setFrase('Deseja apagar o contato?')
        setAcao('apagar')
        
    }

    const carregar = () => {

        //console.log('aqui')

        api.get(`clienteWhatsapps/${props.cliente_id}`).then((result) => {

            //console.log(result.data)
            props.setTotalWhatsapp(result.data.length)
          
            setResultado(result.data.map((item: iClienteWhatsapp) => 
            
                <tr key={item.clienteWhatsapp_id}>
                    <td style={{ textAlign: 'left' }}>{item.nome}</td>
                    <td style={{ textAlign: 'center' }}>{item.telefone}</td>
                    <td style={{ textAlign: 'center' }}>
                        <button type="button" className="btn btn-danger btn-sm" onClick={() => {setClienteWhatsapp_id(item.clienteWhatsapp_id);validaApagar()}}>X</button>
                    </td>
                </tr>

            ))

        }).catch((error) => {
            //toast.error('Erro ao carregar os contatos!')
            console.log(error.response)
        })
    }

    useEffect(() => {

        if (props.cliente_id) {
            carregar()
        }
        
    }, [props.cliente_id])

    const apagar = () => {
        
        setOpen(false)
        api.delete(`clienteWhatsapp/${clienteWhatsapp_id}`).then((result) => {
            
            if (result.data.status == 'ok') {
                
                toast.success('Contato apagado com sucesso!')
                carregar()

            }
            
        }).catch((err) => {
            toast.error('Erro ao apagar o contato!')
        })

    }

    const salvar = () => {

        setOpen(false)

        var dataPost = {

            nome: nome,
            telefone: telefone,
            usuario_id: usuario_id_session,
            

        }

        //console.log(`clienteWhatsapp/${props.cliente_id}`)
        //return false

        api.post(`clienteWhatsapp/${props.cliente_id}`, dataPost).then((result) => {

            console.log(result.data)

            if (result.data.status == 'ok') {

                toast.success('Contato salvo com sucesso!')
                setTelefone('')
                setNome('')
                carregar()


            } else {
                toast.error('Erro ao salvar o contato!')    
            }

            
        }).catch((err) => {
            toast.error('Erro ao salvar o contato!')
        })

    }

    return (

        <div className="row g-3">

            <div className="col-md-2">
                <label className="form-label">Tel Celular *</label>
                <TextInput placeholder="(00) 00000-0000" maskType="phone" type="text" className="form-control" value={telefone} onChange={event => setTelefone(event.target.value)} />
            </div>

            <div className="col-md-4">
                <label className="form-label">Contato *</label>
                <input type="text" className="form-control" value={nome} onChange={event => setNome(event.target.value)} maxLength={150} />
            </div>
            <div className="col-md-4" style={{ marginTop: '45px' }}>
            <button type="button" className="btn btn-success" style={{ marginLeft: 5 }} onClick={validaSalvar}>Salvar</button>
            </div>


            <div className="col-md-12"> 

                <table className="table table-hover">
                    <thead>
                        <tr>
                            <th style={{ textAlign: 'left', backgroundColor: '#EFEFEF' }}>

                                Nome

                            </th>
                            <th style={{  backgroundColor: '#EFEFEF', textAlign: 'center' }}>

                                Telefone

                            </th>

                            <th style={{ backgroundColor: '#EFEFEF', textAlign: 'center' }}>

                                &nbsp;

                            </th>

                        </tr>

                    </thead>
                    <tbody>

                        {resultado}

                    </tbody>

                </table>


            </div>



                <Dialog
                    open={open}
                    TransitionComponent={Transition}
                    keepMounted
                    onClose={() => setOpen(false)}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    maxWidth="xs"
                    fullWidth
                >
                    <DialogTitle id="alert-dialog-title">{titulo}</DialogTitle>
                    <DialogContent sx={{ display: "flex", flexDirection: "column" }}>

                        <div style={{ textAlign: 'justify' }}>
                            {frase}
                        </div>

                    </DialogContent>
                    <DialogActions>



                        <Button color="error" variant="contained" onClick={() => setOpen(false)} >
                            Cancelar
                        </Button>
                        <Button color="success" variant="contained" onClick={() => acao == 'apagar' ? apagar() : salvar()} >
                            Ok
                        </Button>


                    </DialogActions>
                </Dialog>

        </div>

    )

}

export default ClienteWhatsapp;